
<H1>{{serviceTarget}} - Quick Service</H1>

<div>
    <ServiceRequestLogEntryForm [target]='serviceTarget'> </ServiceRequestLogEntryForm>
</div>

<div *ngIf="loginDisplay">
    <newServiceRequest-form [target]='serviceTarget' (onNewServiceRequest)="refreshServiceRequestList()"></newServiceRequest-form>
</div>

<div *ngIf="loginDisplay" class="section-view">
    <h1>Open Service Requests</h1>
    <serviceRequest-list #serviceRequestList [tag]= 'serviceTarget' [state]= 'open'></serviceRequest-list>
</div>




